import passengerTypeCopy from './passenger-types-copy';
import passengerTypesEnum from './passenger-types-enum';

const defaultPassengersMap = [
  {
    type: passengerTypesEnum.ADULT,
    copyID: passengerTypeCopy.ADULT,
    min: 0,
    ageMin: 12,
    ageMax: null,
  },
  {
    type: passengerTypesEnum.CHILD,
    copyID: passengerTypeCopy.CHILD,
    min: 0,
    ageMin: 2,
    ageMax: 11,
  },
  {
    type: passengerTypesEnum.INFANT,
    copyID: passengerTypeCopy.INFANT,
    min: 0,
    ageMin: 0,
    ageMax: 2,
  },
];

const vacationBookerPassengersMap = [
  {
    type: passengerTypesEnum.ADULT,
    copyID: passengerTypeCopy.ADULT,
    min: 0,
    ageMin: 17,
    ageMax: null,
  },
  {
    type: passengerTypesEnum.CHILD,
    copyID: passengerTypeCopy.CHILD,
    min: 0,
    ageMin: 0,
    ageMax: 17,
  },
];

const vacationBookerPassengersMapAdult = [
  {
    type: passengerTypesEnum.ADULT,
    copyID: passengerTypeCopy.ADULT,
    min: 0,
    ageMin: 18,
    ageMax: null,
  },
];

const vacationBookerPassengersMapChild = [
  {
    type: passengerTypesEnum.CHILD,
    copyID: passengerTypeCopy.CHILD,
    min: 0,
    ageMin: 0,
    ageMax: 17,
  },
];

const vacationBookerPassengersMapInfant = [
  {
    type: passengerTypesEnum.INFANT,
    copyID: passengerTypeCopy.INFANT,
    min: 0,
    ageMin: 0,
    ageMax: 2,
  },
];

const hotelBookerPassengersMap = [
  {
    type: passengerTypesEnum.ADULT,
    copyID: passengerTypeCopy.ADULT,
    min: 0,
    ageMin: 17,
    ageMax: null,
  },
  {
    type: passengerTypesEnum.CHILD,
    copyID: passengerTypeCopy.CHILD,
    min: 0,
    ageMin: 0,
    ageMax: 17,
  },
];

export default { defaultPassengersMap, vacationBookerPassengersMap, vacationBookerPassengersMapAdult, vacationBookerPassengersMapChild, vacationBookerPassengersMapInfant, hotelBookerPassengersMap };
